import { List as AntList, EmptyProps, ListProps } from "antd";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";
import Empty from "./empty";
import ContentLoader from "./contentLoader";

type Props<T> = ListProps<T> & { hoverable?: boolean; empty?: EmptyProps };

const List = <T extends unknown>({
  hoverable,
  bordered,
  className = "",
  empty,
  ...props
}: Props<T>) => (
  <AntList
    {...props}
    bordered={bordered}
    className={`overflow-hidden rounded-card [&_.ant-list-item]:px-[2rem] [&_.ant-list-item]:py-[1.8rem] ${
      !bordered ? "border-0 bg-white" : ""
    } ${
      hoverable
        ? "[&_.ant-list-item]:cursor-pointer [&_.ant-list-item:hover]:bg-[#fcfcfc]"
        : ""
    } ${className}`}
    locale={{
      emptyText: (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={empty?.description}
        />
      ),
    }}
  />
);

const AntMeta = AntList.Item.Meta;

const Meta = ({
  description,
  className,
  ...props
}: ComponentProps<typeof AntMeta>) => (
  <AntMeta
    {...props}
    description={description}
    className={twMerge(
      !description && "!items-center [&_.ant-list-item-meta-title]:!mb-0",
      className,
    )}
  />
);

List.Item = AntList.Item;
List.Item.Meta = Meta;

const ListItemSkeleton = ({ uniqueKey }: { uniqueKey: string }) => (
  <List.Item
    extra={
      <ContentLoader
        uniqueKey={`${uniqueKey}-button`}
        style={{ width: "8.3rem", height: "3.2rem" }}
      >
        <rect x="0" y="8" rx="4" ry="4" width="83" height="32" />
      </ContentLoader>
    }
  >
    <List.Item.Meta
      avatar={
        <ContentLoader
          uniqueKey={`${uniqueKey}-content`}
          viewBox="0 0 350 90"
          style={{ width: "100%", height: "7.2rem" }}
        >
          <rect x="0" y="8" rx="8" ry="8" width="50" height="50" />
          <rect x="64" y="4" rx="4" ry="4" width="180" height="14" />
          <rect x="64" y="28" rx="4" ry="4" width="90" height="14" />
          <rect x="64" y="50" rx="4" ry="4" width="160" height="12" />
          <rect x="64" y="70" rx="6" ry="6" width="75" height="18" />
        </ContentLoader>
      }
    />
  </List.Item>
);

List.ItemSkeleton = ListItemSkeleton;

export default List;
